import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBell"><Path d="M12.0001 2C7.7923 2 4.26157 5.17264 3.8133 9.35647L3.00011 17.5H21.0001L20.1868 9.35648C19.7386 5.17264 16.2079 2 12.0001 2Z" fill="currentColor"/><Path d="M16.584 19H7.41612C8.18768 20.7659 9.94976 22 12.0001 22C14.0504 22 15.8125 20.7659 16.584 19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBell;
